import { render, staticRenderFns } from "./ModalTitle.vue?vue&type=template&id=2e36c766&"
import script from "./ModalTitle.vue?vue&type=script&lang=js&"
export * from "./ModalTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModalTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports